/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection08FoiChanged, m11ReportSection08ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection08Foi, selectM11ReportSection08Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialAssessmentsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section08State, setAlertModalState, setStartingSection08State) => {

    let changesStates = {
        section08State: section08State
    };
    let response = await saveM11Changes(apiToken, 27, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection08Resource) {
            dispatch(m11ReportSection08ResourceChanged(response.m11ReportSection08Resource));
        }
        setStartingSection08State(JSON.parse(JSON.stringify(section08State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step027TrialAssessmentsPart1 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection08Foi = useSelector(selectM11ReportSection08Foi);
    const m11ReportSection08Resource = useSelector(selectM11ReportSection08Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section08State, setSection08State] = useState({
        "section82Status": "empty", "section82Xhtml": "",
        "section81Status": "empty", "section81Xhtml": "",
        "section83Status": "empty", "section83Xhtml": ""
    });
    const [startingSection08State, setStartingSection08State] = useState({
        "section82Status": "empty", "section82Xhtml": "",
        "section81Status": "empty", "section81Xhtml": "",
        "section83Status": "empty", "section83Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section08State, startingSection08State)),
        async saveAllChanges() {
            await saveTrialAssessmentsChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section08State, setAlertModalState, setStartingSection08State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section82Status": "empty", "section82Xhtml": "",
                "section81Status": "empty", "section81Xhtml": "",
                "section83Status": "empty", "section83Xhtml": "",
                "loaded": true
            };
            setSection08State(startingData);
            setStartingSection08State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[8]?.entry?.length) {
                let m11ReportSection008Foi = getIdFromReference(m11ReportContainerResource.section[8].entry[0]);
                if (m11ReportSection008Foi && !isNaN(m11ReportSection008Foi) && m11ReportSection008Foi !== m11ReportSection08Foi) {
                    dispatch(m11ReportSection08FoiChanged(m11ReportSection008Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection08Foi && !isNaN(m11ReportSection08Foi)) {
            loadResource(m11ReportSection08Foi, "M11ReportSection08", apiToken, dispatch);
        }
    }, [m11ReportSection08Foi]);

    useEffect(() => {
        if (m11ReportSection08Resource && Object.keys(m11ReportSection08Resource).length > 0) {
            let startingData = {
                "section82Status": "empty", "section82Xhtml": "",
                "section81Status": "empty", "section81Xhtml": "",
                "section83Status": "empty", "section83Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection08Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection08Resource.section[0].section[0]?.text?.div &&
                    m11ReportSection08Resource.section[0].section[0].text.status !== "empty") {
                    startingData.section81Status = m11ReportSection08Resource.section[0].section[0].text.status;
                    startingData.section81Xhtml = m11ReportSection08Resource.section[0].section[0].text.div;
                }
                if (m11ReportSection08Resource.section[0].section[1]?.text?.div &&
                    m11ReportSection08Resource.section[0].section[1].text.status !== "empty") {
                    startingData.section82Status = m11ReportSection08Resource.section[0].section[1].text.status;
                    startingData.section82Xhtml = m11ReportSection08Resource.section[0].section[1].text.div;
                }
                if (m11ReportSection08Resource.section[0].section[2]?.text?.div &&
                    m11ReportSection08Resource.section[0].section[2].text.status !== "empty") {
                    startingData.section83Status = m11ReportSection08Resource.section[0].section[2].text.status;
                    startingData.section83Xhtml = m11ReportSection08Resource.section[0].section[2].text.div;
                }
                setSection08State(startingData);
                setStartingSection08State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection08Resource]);

    return <div>
        <h3>Start Section 8 Trial Assessments and Procedures</h3>
        {!(m11ReportSection08Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 27 (Start Section 8 Trial Assessments and Procedures) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section08State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.1 Trial Assessments and Procedures Considerations as needed.</h4>
                    <TextDivEntry elementName="section81Xhtml"
                        startingValue={section08State.section81Xhtml}
                        setResourceState={setSection08State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.2 Screening/Baseline Assessments and Procedures summary as needed.</h4>
                    <TextDivEntry elementName="section82Xhtml"
                        startingValue={section08State.section82Xhtml}
                        setResourceState={setSection08State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.3 Efficacy Assessments and Procedures summary as needed.</h4>
                    <TextDivEntry elementName="section83Xhtml"
                        startingValue={section08State.section83Xhtml}
                        setResourceState={setSection08State} />
                </>}
            </>
        }
    </div >
});

const M11Step027TrialAssessmentsPart1HelperText = <div>
    <h3>Start Section 8 Trial Assessments and Procedures</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 8.1 Trial Assessments and Procedures Considerations.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe general considerations applicable across trial assessments and procedures.</p>
        </div>
        <p>Enter data for Section 8.2 Screening/Baseline Assessments and Procedures.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe any assessments and procedures that are unique to screening/baseline (e.g., collection of data on participant characteristics, assessments/procedures performed for the purpose of determining eligibility or for stratification) in this section.</p>
            <p>Describe screening and baseline assessments and procedures separately when screening and baseline are different or performed at different visits.</p>
        </div>
        <p>Enter data for Section 8.3 Efficacy Assessments and Procedures.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe efficacy assessments and procedures in this section. Cross reference Section 8.7 Immunogenicity Assessments if immunogenicity assessments are used in efficacy determination.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step027TrialAssessmentsPart1ValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 27, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
        <h4>Step 27 (Start Section 8 Trial Assessments and Procedures) {validationCheckState.step27numberOfChecks} issues checked. {validationCheckState.step27numberPassed} passed. {validationCheckState.step27numberFailed} failed.</h4>
        <p>Section 8.1 heading is 'Trial Assessments and Procedures Considerations': {validationCheckState.resultCheckSection81Heading}</p>
        <p>Section 8.1 Trial Assessments and Procedures Considerations has content: {validationCheckState.resultCheckSection81Content}</p>
        <p>Section 8.2 heading is 'Screening/Baseline Assessments and Procedures': {validationCheckState.resultCheckSection82Heading}</p>
        <p>Section 8.2 Screening/Baseline Assessments and Procedures has content: {validationCheckState.resultCheckSection82Content}</p>
        <p>Section 8.3 heading is 'Efficacy Assessments and Procedures': {validationCheckState.resultCheckSection83Heading}</p>
        <p>Section 8.3 Efficacy Assessments and Procedures has content: {validationCheckState.resultCheckSection83Content}</p>
    </div>}  </div>
}

export default M11Step027TrialAssessmentsPart1;
export { M11Step027TrialAssessmentsPart1HelperText, M11Step027TrialAssessmentsPart1ValidationCheck };